import { IMessagingService } from "../services";
import { Component } from "./component";

class TextComponent extends Component {
    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);
    }
}

export { TextComponent };